"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CmsBotEditor = /** @class */ (function (_super) {
    __extends(CmsBotEditor, _super);
    function CmsBotEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        return _this;
    }
    CmsBotEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AU = this.props.dataUsrPlayers.Subscribe("*", function (id, data) {
            _this.setState({ brand_usr_players_avail: data.data });
        });
        this.SID_GG = this.props.dataGameProviderGames.Subscribe("*", function (id, data) {
            _this.setState({ gws_gameprovider_games_avail: data.data });
        });
        this.SID_GS = this.props.dataGameSets.Subscribe("*", function (id, data) {
            _this.setState({ cms_gameprovider_gamesets_avail: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    bot_tag: _item.bot_tag,
                    min_timeout_win_sec: _item.min_timeout_win_sec,
                    max_timeout_win_sec: _item.max_timeout_win_sec,
                    usr_player_id: _item.usr_player_id,
                    usr_player_login: _item.usr_player_login,
                    is_locked: _item.is_locked,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    max_win_amount: _item.max_win_amount,
                    min_win_amount: _item.min_win_amount,
                    brand_usr_players_avail: [],
                    gws_gameprovider_games_avail: [],
                    cms_gameprovider_gamesets_avail: [],
                    gws_gameprovider_id: _item.gws_gameprovider_id,
                    gws_gameprovider_title: _item.gws_gameprovider_title,
                    gws_gameprovider_game_id: _item.gws_gameprovider_game_id,
                    gws_gameprovider_game_title: _item.gws_gameprovider_game_title,
                    cms_gameprovider_gameset_id: _item.cms_gameprovider_gameset_id,
                    cms_gameprovider_gameset_title: _item.cms_gameprovider_gameset_title,
                    is_auto_change_game: _item.is_auto_change_game,
                    change_game_min_timeout_sec: _item.change_game_min_timeout_sec,
                    change_game_max_timeout_sec: _item.change_game_max_timeout_sec,
                    tabKey: this.key_main
                }, function () {
                    _this.LoadUserPlayers();
                    _this.LoadGames();
                    _this.LoadGameSets();
                    _this.props.state.setExtBreadCrumbPath(["Редактирование бота"]);
                });
            }
        }
        else {
            this.setState({
                bot_tag: "",
                usr_player_id: 0,
                is_locked: false,
                brand_id: 0,
                brand_title: "",
                usr_player_login: "",
                max_win_amount: 10000,
                min_win_amount: 100,
                brand_usr_players_avail: [],
                gws_gameprovider_games_avail: [],
                cms_gameprovider_gamesets_avail: [],
                gws_gameprovider_id: 0,
                gws_gameprovider_title: "",
                gws_gameprovider_game_id: 0,
                gws_gameprovider_game_title: "",
                cms_gameprovider_gameset_id: 0,
                cms_gameprovider_gameset_title: "",
                is_auto_change_game: false,
                change_game_min_timeout_sec: 100,
                change_game_max_timeout_sec: 100,
                min_timeout_win_sec: 1,
                max_timeout_win_sec: 2,
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание бота"]);
            });
        }
        this.doReSetRules();
    };
    CmsBotEditor.prototype.LoadUserPlayers = function () {
        this.props.dataUsrPlayers.LoadData(this.state.brand_id);
    };
    CmsBotEditor.prototype.LoadGameSets = function () {
        this.props.dataGameSets.LoadData(this.state.gws_gameprovider_id);
    };
    CmsBotEditor.prototype.LoadGames = function () {
        this.props.dataGameProviderGames.LoadData(this.state.gws_gameprovider_id);
    };
    CmsBotEditor.prototype.componentWillUnmount = function () {
        this.props.dataUsrPlayers.UnSubscribe(this.SID_AU);
        this.props.dataGameProviderGames.UnSubscribe(this.SID_GG);
        this.props.dataGameSets.UnSubscribe(this.SID_GS);
    };
    CmsBotEditor.prototype.doReSetRules = function () {
        this.setState({
            bot_tag_rules: { isError: false },
            brand_rules: { isError: false },
            usr_player_rules: { isError: false },
            min_timeout_win_sec_rules: { isError: false },
            max_timeout_win_sec_rules: { isError: false },
            min_win_amount_rules: { isError: false },
            max_win_amount_rules: { isError: false },
            gws_gameprovider_rules: { isError: false },
            gws_gameprovider_game_rules: { isError: false },
            cms_gameprovider_gameset_rules: { isError: false },
            change_game_min_timeout_sec_rules: { isError: false },
            change_game_max_timeout_sec_rules: { isError: false }
        });
    };
    CmsBotEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.bot_tag) || (this.state.bot_tag.length === 0)) {
            this.setState({
                bot_tag_rules: {
                    isError: true,
                    errorMessage: "Поле [тэг бота] не заполнено!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.min_timeout_win_sec) || (this.state.min_timeout_win_sec <= 0)) {
            this.setState({
                min_timeout_win_sec_rules: {
                    isError: true,
                    errorMessage: "Поле [минимальный интервал выигрыша] имеет некорректное значение!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.max_timeout_win_sec) || (this.state.max_timeout_win_sec <= 0)) {
            this.setState({
                max_timeout_win_sec_rules: {
                    isError: true,
                    errorMessage: "Поле [максимальный интервал выигрыша] имеет некорректное значение!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.min_timeout_win_sec > this.state.max_timeout_win_sec) {
            this.setState({
                min_timeout_win_sec_rules: {
                    isError: true,
                    errorMessage: "Поле [Максимальный интервал выигрыша] меньше минимального!"
                },
                max_timeout_win_sec_rules: {
                    isError: true,
                    errorMessage: "Поле [Минимальный интервал выигрыша] больше максимального!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true,
                    errorMessage: "Поле [бренд] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.usr_player_id <= 0) || (this.state.usr_player_login.length === 0)) {
            this.setState({
                usr_player_rules: {
                    isError: true,
                    errorMessage: "Поле [игрок] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.gws_gameprovider_id <= 0) || (this.state.gws_gameprovider_title.length === 0)) {
            this.setState({
                gws_gameprovider_rules: {
                    isError: true, errorMessage: "Поле [геймпровайдер] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.gws_gameprovider_game_id <= 0) || (this.state.gws_gameprovider_game_title.length === 0)) {
            this.setState({
                gws_gameprovider_game_rules: {
                    isError: true,
                    errorMessage: "Поле [игра] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.min_win_amount <= 0) || (this.state.min_win_amount >= 999999)) {
            this.setState({
                min_win_amount_rules: {
                    isError: true,
                    errorMessage: "Поле [минимальный выигрыш] заполнено некорректно!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((this.state.max_win_amount <= 0) || (this.state.max_win_amount >= 999999)) {
            this.setState({
                max_win_amount_rules: {
                    isError: true,
                    errorMessage: "Поле [максимальный выигрыш] заполнено некорректно!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.min_win_amount > this.state.max_win_amount) {
            this.setState({
                min_win_amount_rules: {
                    isError: true,
                    errorMessage: "Поле [Максимальная сумма выигрыша] меньше минимальной!"
                },
                max_win_amount_rules: {
                    isError: true,
                    errorMessage: "Поле [Минимальная сумма выигрыша] больше максимальной!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.is_auto_change_game) {
            if ((this.state.change_game_min_timeout_sec < 1) || (this.state.change_game_min_timeout_sec >= 999999)) {
                this.setState({
                    change_game_min_timeout_sec_rules: {
                        isError: true,
                        errorMessage: "Поле [Минимальный интервал переключения игры] заполнено некорректно!"
                    },
                    tabKey: this.key_additional
                });
                return false;
            }
            if ((this.state.change_game_max_timeout_sec < 1) || (this.state.change_game_max_timeout_sec >= 999999)) {
                this.setState({
                    change_game_max_timeout_sec_rules: {
                        isError: true,
                        errorMessage: "Поле [Максимальный интервал переключения игры] заполнено некорректно!"
                    },
                    tabKey: this.key_additional
                });
                return false;
            }
            if (this.state.change_game_min_timeout_sec > this.state.change_game_max_timeout_sec) {
                this.setState({
                    change_game_max_timeout_sec_rules: {
                        isError: true,
                        errorMessage: "Поле [Максимальный интервал переключения игры] меньше минимального!"
                    },
                    change_game_min_timeout_sec_rules: {
                        isError: true,
                        errorMessage: "Поле [Минимальный интервал переключения игры] больше максимального!"
                    },
                    tabKey: this.key_additional
                });
                return false;
            }
            if ((this.state.cms_gameprovider_gameset_id <= 0) || (this.state.cms_gameprovider_gameset_title.length === 0)) {
                this.setState({
                    cms_gameprovider_gameset_rules: {
                        isError: true,
                        errorMessage: "Поле [набор игр] не выбрано!"
                    },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        return true;
    };
    CmsBotEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                usr_player_id: this.state.usr_player_id,
                max_win_amount: this.state.max_win_amount,
                is_locked: this.state.is_locked,
                min_win_amount: this.state.min_win_amount,
                bot_tag: this.state.bot_tag,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                change_game_min_timeout_sec: this.state.change_game_min_timeout_sec,
                change_game_max_timeout_sec: this.state.change_game_max_timeout_sec,
                cms_gameprovider_gameset_id: this.state.cms_gameprovider_gameset_id,
                is_auto_change_game: this.state.is_auto_change_game,
                min_timeout_win_sec: this.state.min_timeout_win_sec,
                max_timeout_win_sec: this.state.max_timeout_win_sec
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бот изменен!");
            });
        }
    };
    CmsBotEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.state.usr_player_id,
                max_win_amount: this.state.max_win_amount,
                min_win_amount: this.state.min_win_amount,
                brand_id: this.state.brand_id,
                is_locked: this.state.is_locked,
                bot_tag: this.state.bot_tag,
                min_timeout_win_sec: this.state.min_timeout_win_sec,
                max_timeout_win_sec: this.state.max_timeout_win_sec,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                change_game_min_timeout_sec: this.state.change_game_min_timeout_sec,
                change_game_max_timeout_sec: this.state.change_game_max_timeout_sec,
                cms_gameprovider_gameset_id: this.state.cms_gameprovider_gameset_id,
                is_auto_change_game: this.state.is_auto_change_game,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бот добавлен!");
            });
        }
    };
    CmsBotEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг бота:", placeholder: "Введите тэг бота" }, value: this.state.bot_tag, onValueChanged: function (newVal) { _this.setState({ bot_tag: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                        brand_usr_players_avail: [],
                        usr_player_id: 0,
                        usr_player_login: ""
                    }, function () {
                        _this.LoadUserPlayers();
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игрок:", placeholder: "Выберите игрока" }, value: {
                    key: this.state.usr_player_id, value: this.state.usr_player_login
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_player_id: newVal.key,
                        usr_player_login: newVal.value,
                        usr_player_rules: { isError: false }
                    });
                }, items: this.state.brand_usr_players_avail, required: true, rules: this.state.usr_player_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: { key: this.state.gws_gameprovider_id, value: this.state.gws_gameprovider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_id: newVal.key,
                        gws_gameprovider_title: newVal.value,
                        gws_gameprovider_rules: { isError: false },
                        gws_gameprovider_game_id: 0,
                        gws_gameprovider_game_title: "",
                        gws_gameprovider_game_rules: { isError: false },
                        gws_gameprovider_games_avail: [],
                        cms_gameprovider_gameset_id: 0,
                        cms_gameprovider_gameset_title: "",
                        cms_gameprovider_gameset_rules: { isError: false },
                        cms_gameprovider_gamesets_avail: []
                    }, function () {
                        _this.LoadGameSets();
                        _this.LoadGames();
                    });
                }, items: this.props.gwsGameProvidersAvail, required: true, rules: this.state.gws_gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Игра:",
                    placeholder: "Выберите игру"
                }, value: {
                    key: this.state.gws_gameprovider_game_id,
                    value: this.state.gws_gameprovider_game_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_game_id: newVal.key,
                        gws_gameprovider_game_title: newVal.value,
                        gws_gameprovider_game_rules: { isError: false }
                    });
                }, items: this.state.gws_gameprovider_games_avail, required: true, rules: this.state.gws_gameprovider_game_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бот заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({ is_locked: checked });
                } }),
            this.getDownButtons()));
    };
    CmsBotEditor.prototype.getAdditionalContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Минимальный выигрыш:",
                    placeholder: "Введите минимальный выигрыш"
                }, values: {
                    max: 999999,
                    min: 10,
                    value: this.state.min_win_amount
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_win_amount: newVal,
                        min_win_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.min_win_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Максимальный выигрыш:",
                    placeholder: "Введите максимальный выигрыш"
                }, values: {
                    max: 999999,
                    min: 10,
                    value: this.state.max_win_amount
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_win_amount: newVal,
                        max_win_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.max_win_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Минимальный интервал, сек:",
                    placeholder: "Введите минимальный интервал выигрыша"
                }, values: {
                    max: 999999,
                    min: 1,
                    value: this.state.min_timeout_win_sec
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_timeout_win_sec: newVal,
                        min_timeout_win_sec_rules: { isError: false }
                    });
                }, required: true, rules: this.state.min_timeout_win_sec_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Максимальный интервал, сек:",
                    placeholder: "Введите максимальный интервал выигрыша"
                }, values: {
                    max: 999999,
                    min: 1,
                    value: this.state.max_timeout_win_sec
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_timeout_win_sec: newVal,
                        max_timeout_win_sec_rules: { isError: false }
                    });
                }, required: true, rules: this.state.max_timeout_win_sec_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Автоматическое переключение игры", value: this.state.is_auto_change_game, onChecked: function (checked) { _this.setState({ is_auto_change_game: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Набор игр:",
                    placeholder: "Выберите набор игр"
                }, value: {
                    key: this.state.cms_gameprovider_gameset_id,
                    value: this.state.cms_gameprovider_gameset_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        cms_gameprovider_gameset_id: newVal.key,
                        cms_gameprovider_gameset_title: newVal.value,
                        gws_gameprovider_game_rules: { isError: false }
                    });
                }, items: this.state.cms_gameprovider_gamesets_avail, required: true, rules: this.state.cms_gameprovider_gameset_rules, disabled: !this.state.is_auto_change_game }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Минимальный интервал, сек.:",
                    placeholder: "Введите минимальный интервал переключения игры, сек."
                }, values: {
                    max: 999999,
                    min: 10,
                    value: this.state.change_game_min_timeout_sec
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        change_game_min_timeout_sec: newVal,
                        change_game_min_timeout_sec_rules: { isError: false }
                    });
                }, required: true, rules: this.state.change_game_min_timeout_sec_rules, disabled: !this.state.is_auto_change_game }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Максимальный интервал, сек.:",
                    placeholder: "Введите максимальный интервал переключения игры, сек."
                }, values: {
                    max: 999999,
                    min: 60,
                    value: this.state.change_game_max_timeout_sec
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        change_game_max_timeout_sec: newVal,
                        change_game_max_timeout_sec_rules: { isError: false }
                    });
                }, required: true, rules: this.state.change_game_max_timeout_sec_rules, disabled: !this.state.is_auto_change_game }),
            this.getDownButtons()));
    };
    CmsBotEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsBotEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить бота";
        }
        else {
            return "Изменить бота";
        }
    };
    CmsBotEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    CmsBotEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalContent();
        }
        return null;
    };
    CmsBotEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    CmsBotEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return CmsBotEditor;
}(React.Component));
exports.default = CmsBotEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_bots/ui/component/CmsBotEditor.tsx
// module id = 2334
// module chunks = 0